/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DeepAnalysisControllerStartMutationRequest, DeepAnalysisControllerStartMutationResponse, DeepAnalysisControllerStart400, DeepAnalysisControllerStart401, DeepAnalysisControllerStart403, DeepAnalysisControllerStart404 } from "../../models/aiAgentV2Controller/DeepAnalysisControllerStart";

function getDeepAnalysisControllerStartUrl() {
  const res = { method: 'POST', url: `/api/v1/ai-agent-v2/deep-analysis` as const }  
  return res
}

/**
 * @summary Start a deep analysis session
 * {@link /api/v1/ai-agent-v2/deep-analysis}
 */
export async function deepAnalysisControllerStart(data?: DeepAnalysisControllerStartMutationRequest, config: Partial<RequestConfig<DeepAnalysisControllerStartMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DeepAnalysisControllerStartMutationResponse, ResponseErrorConfig<DeepAnalysisControllerStart400 | DeepAnalysisControllerStart401 | DeepAnalysisControllerStart403 | DeepAnalysisControllerStart404>, DeepAnalysisControllerStartMutationRequest>({ method : "POST", url : getDeepAnalysisControllerStartUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}